import React from 'react';
import { Link } from 'react-router-dom';
import { projects } from '../../data/siteData';
import '../collection-pages.css';

const WorkPage = () => <article className="record-page collection-record">
  <header className="collection-record__header"><div><p className="record-kicker">Personal files / Projects</p><h1>Project files</h1></div><div><span>{projects.filter((project) => !project.hidden).length} files</span><p>Notes, background, and development history for selected projects.</p></div></header>
  <div className="project-register">
    <div className="register-head"><span>File</span><span>Record</span><span>State</span></div>
    {projects.filter((project) => !project.hidden).map((project, index) => <article className="project-record-row" key={project.id}>
      <span className="project-record-row__id">{String(index + 1).padStart(2, '0')}<i>{project.year}</i></span>
      <div className="project-record-row__copy"><span>{project.category}</span><h2><Link to={`/work/${project.id}`}>{project.title}</Link></h2><p>{project.summary}</p></div>
      <div className="project-record-row__state"><span>{project.status}</span><i>{project.destinationLabel?.toUpperCase() || (project.link ? 'SOURCE AVAILABLE' : 'REFERENCE FILE')}</i></div>
    </article>)}
  </div>
</article>;

export default WorkPage;
